import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './screens/login/login.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardComponent } from './screens/dashboard/dashboard.component';
import { FooterComponent } from './components/footer/footer.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpClientXsrfModule} from "@angular/common/http";
import {ErrorInterceptor, fakeBackendProvider, JwtInterceptor} from "./helpers";
import {AlertComponent} from "@app/components/alert/alert.component";
import {CookiesService} from "@app/services/cookie.service";
import { MenuLeftComponent } from './components/menu-left/menu-left.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LayoutClearComponent } from './components/layout-clear/layout-clear.component';
import { LayoutMenuLeftComponent } from './components/layout-menu-left/layout-menu-left.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { SetMomentsComponent } from './screens/set-moments/set-moments.component';
import { LayoutMomentsComponent } from './screens/set-moments/layout-moments/layout-moments.component';
import { SetFormsComponent } from './screens/set-forms/set-forms.component';
import { FooterAdminComponent } from './components/footer-admin/footer-admin.component';
import { LayoutOrganizationsComponent } from './screens/set-organizations/layout-organizations/layout-organizations.component';
import {NotifierModule} from "angular-notifier";
import {ForgetPasswordComponent} from "@app/screens/forget-password/forget-password.component";
import {ResetPasswordComponent} from "@app/screens/reset-password/reset-password.component";
import {ConfirmDialogModule} from "@app/components/confirm-dialog/confirm-dialog.module";
import { ActivitiesComponent } from './screens/activities/activities.component';
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";
import { ImportComponent } from './components/import/import.component';

// import ngx-translate and the http loader
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgSelectModule} from "@ng-select/ng-select";
import {DirectivesModule} from "@app/directives/directives.module";

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    FooterComponent,
    AlertComponent,
    MenuLeftComponent,
    NavbarComponent,
    LayoutClearComponent,
    LayoutMenuLeftComponent,
    SetMomentsComponent,
    LayoutMomentsComponent,
    SetFormsComponent,
    FooterAdminComponent,
    LayoutOrganizationsComponent,
    ActivitiesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'DYAUTH',
      headerName: 'X-CSRFToken',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({maxAge: 25, logOnly: environment.production}),
    ConfirmDialogModule,
    DirectivesModule,
    NgMultiSelectDropDownModule.forRoot(),
    NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'right'
        }
      },
      behaviour: {
        autoHide: 3000,
      }
    })
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    CookiesService,
    // provider used to create fake backend
    fakeBackendProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
